<template>
  <div class="flex items-center justify-center bg-base-100">
    <div class="text-center max-w-md mx-4 mt-10">
      <div class="mb-8">
        <img src="@/assets/icons/warning-2.svg" alt="Access Denied" class="w-16 h-16 mx-auto mb-4 icon">
        <h1 class="text-3xl font-bold text-base-content mb-2">Access Denied</h1>
        <p class="text-base-content/70">
          You don't have permission to access this company. Please contact your administrator or verify you're accessing the correct company.
        </p>
      </div>
      
      <div class="space-y-3">
        <NuxtLink 
          to="/company" 
          class="btn btn-primary w-full"
        >
          View My Companies
        </NuxtLink>
        
        <button 
          @click="$router.go(-1)" 
          class="btn btn-ghost w-full"
        >
          Go Back
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>

definePageMeta({
  layout: 'default'
})

useSeoMeta({
  title: 'Access Denied - SupaPM',
  description: 'You don\'t have permission to access this resource.'
})

</script> 